var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModeMetro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-train") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-subway"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_subway"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.45070423e-06,3.0096507 C-8.45070423e-06,1.39269296 1.34745634,0.045228169 2.96441408,0.045228169 L20.9304423,0.045228169 C22.6074,0.045228169 23.9547803,1.39269296 23.9547803,3.0096507 L23.9547803,20.9757634 C23.9547803,22.6525521 22.6074,24.0000169 20.9304423,24.0000169 L2.96441408,24.0000169 C1.34745634,24.0000169 -8.45070423e-06,22.6525521 -8.45070423e-06,20.9757634 L-8.45070423e-06,3.0096507 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2609854,9.10639685 L17.2609854,8.60241099 C17.2609854,8.57270569 17.3213118,8.54308408 17.381553,8.54308408 L17.381553,20.64 L21.12,20.64 L21.12,2.88 L15.6028191,2.88 L12.1356279,15.0066212 L12.0753867,15.8367796 L11.9849397,15.8367796 L11.8944927,15.0066212 L8.42738667,2.88 L2.88,2.88 L2.88,20.64 L6.67877334,20.64 L6.67877334,8.54308408 C6.70889397,8.54308408 6.76913523,8.57270569 6.76913523,8.60241099 L6.76913523,9.10639685 L10.1458794,20.64 L13.8542057,20.64 L17.2609854,9.10639685 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeMetro);
export default __webpack_public_path__ + "static/media/mode-metro.2e864db78926ce7fc42258007c83cb5e.svg";
export { ForwardRef as ReactComponent };